import { urls } from "../../../Routes/Urls";
import classes from "./BlogPostCard.module.css"

const flagPlaceholder = "/Assets/Images/flag_placeholder.png"

function BlogPostCard({label,date,readTime,title,image,description,author,authorRole,countryCode,onClick,isTrending,slug}){
    return(
        <a href={`${urls.VIEWBLOG}/${slug}`} 
        target="_blank" 
        rel="noopener noreferrer"
        className={classes.linkReset}
        onClick={(e) => { 
          e.preventDefault();  // Prevents default link behavior
          onClick();
        }}>
        <div className={classes.container} onClick={onClick}>
            <div className={classes.headerDetails}>
                <div className={classes.label}>
                    <p>{label}</p>
                </div>
                <p>{date} | {readTime}</p>
            </div>

            <div className={classes.blogBody}>
                {/* <p>{description}</p> */}
                <div className={classes.blogImage}>
                    <img src={image} alt="" />
                </div>
                <h2>{title}</h2>
            </div>

            <div className={classes.authorDetails}>
                {/* <img src={authorImage} alt={author} /> */}
                <div className = {classes.author}>
                <i class={`${classes.flag} ${classes[`flag-48`]} ${classes[`flag-${countryCode}`]}`}></i><br />
                    <div className={classes.authorName}>
                        <h3>{author}</h3>
                        <p>{authorRole}</p>
                    </div>
                </div>
                <div className={classes.trending}>
                    {isTrending && 
                        <div className={classes.isTrending}>Trending</div>
                        }
                </div>
            </div>

        </div>
        </a>
    )
}


export default BlogPostCard;